import { useState, useEffect } from 'react';
import { candidateJobOfferService, recruiterJobOfferService } from '@/services/jobOfferService';
import { useAuth } from '@/stores/authStore';

export function useJobOfferNotifications() {
  const { user, isAuthenticated } = useAuth();
  const [unseenCount, setUnseenCount] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!isAuthenticated || !user) {
      setUnseenCount(0);
      setLoading(false);
      return;
    }

    const fetchUnseenCount = async () => {
      try {
        setLoading(true);
        if (user.role === 'CANDIDATE') {
          // For candidates: count PENDING offers + offers with isUpdated flag
          const response = await candidateJobOfferService.listJobOffers({});
          const offers = response.offers || [];

          // Count PENDING offers or offers that have been updated
          const unseenOffers = offers.filter(
            offer => offer.status === 'PENDING' || offer.isUpdated === true
          );

          setUnseenCount(unseenOffers.length);
        } else if (user.role === 'RECRUITER') {
          // For recruiters: count recently responded offers (last 7 days)
          // This prevents the badge from growing forever
          const response = await recruiterJobOfferService.listJobOffers({});
          const offers = response.offers || [];

          // Calculate offers responded to in the last 7 days
          const sevenDaysAgo = new Date();
          sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);

          const recentResponses = offers.filter(offer => {
            if (!offer.respondedAt) return false;
            const respondedDate = new Date(offer.respondedAt);
            return respondedDate >= sevenDaysAgo &&
                   (offer.status === 'ACCEPTED' || offer.status === 'REJECTED');
          });

          setUnseenCount(recentResponses.length);
        }
      } catch (error) {
        console.error('Failed to fetch unseen job offers count:', error);
        setUnseenCount(0);
      } finally {
        setLoading(false);
      }
    };

    fetchUnseenCount();
  }, [isAuthenticated, user]);

  return { unseenCount, loading };
}
